import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';

import { environment } from '../../environments/environment';

import { TrackingTimelineResponse } from '../model/trackingTimelineResponse.model';
import { TrackingTimelineRequest } from '../model/trackingTimelineRequest.model';

import { timeline_fake, parcel_timeline_fake } from '../../assets/commonAssets/fakeData.js';
import { ParcelTrackingTimelineResponse } from '../model/parcel-tracking-timeline-response.model';

@Injectable({
	providedIn: 'root'
})
export class RechercheService {

	constructor(private http: HttpClient) { }

	trackParcelByParcelNumber(trackingRequest: TrackingTimelineRequest) : Observable<TrackingTimelineResponse> {
		if (environment.fakeData) {
			return of(timeline_fake);
		}
		return this.http.post<TrackingTimelineResponse>(environment.apiUrl + 'tracking', trackingRequest, { headers: { 'Content-Type': 'application/json' } });
	}

	getTrackParcelByDoubleSecureCode(secureCode1: String, secureCode2: String, lang: String ) : Observable<ParcelTrackingTimelineResponse> {
		if (environment.fakeData) {
			return of(parcel_timeline_fake);
		}
		return this.http.get<ParcelTrackingTimelineResponse>('v2/getTracking?secureCode1='+secureCode1+"&secureCode2="+secureCode2+"&lang=" +lang);
	}

}
